import React from 'react';
import { UsersIcon, BuildingIcon, GraduationCapIcon, HeartHandshakeIcon, CheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const eventTypes = [{
  icon: BuildingIcon,
  label: 'Corporate Events',
  description: 'Team outings & company parties'
}, {
  icon: UsersIcon,
  label: 'Team Building',
  description: 'Build stronger teams through fun'
}, {
  icon: GraduationCapIcon,
  label: 'Field Trips',
  description: 'Educational & entertaining'
}, {
  icon: HeartHandshakeIcon,
  label: 'Fundraisers',
  description: 'Support your cause'
}];
const features = ['Customizable packages for any group size', 'Dedicated event coordinator', 'Private or semi-private areas available', 'Catering options from our restaurant', 'Flexible scheduling'];
export function GroupEvents() {
  return <section id="events" className="py-16 md:py-24 px-4 bg-pulse-navy relative overflow-hidden" data-id="element-145">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-146">
        <div className="absolute top-0 left-0 w-96 h-96 bg-pulse-blue rounded-full blur-3xl" data-id="element-147" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-pulse-orange rounded-full blur-3xl" data-id="element-148" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 md:mb-16" data-id="element-150">
          <div className="inline-flex items-center gap-2 bg-white/10 text-pulse-blue px-4 py-2 rounded-full mb-6" data-id="element-151">
            <UsersIcon className="h-5 w-5" data-id="element-152" />
            <span className="font-semibold text-sm uppercase tracking-wide" data-id="element-153">
              Coming Soon
            </span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white uppercase tracking-tight" data-id="element-154">
            Group Events & Team Building — Coming Soon
          </h2>

          <p className="mt-6 text-lg text-white/70 max-w-2xl mx-auto" data-id="element-155">
            Planning a corporate outing, team building event, or field trip? Get
            on our list to be the first to book when we open.
          </p>
        </motion.div>

        {/* Event Types Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-156">
          {eventTypes.map((event, index) => {
          const Icon = event.icon;
          return <motion.div key={event.label} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center hover:bg-white/15 transition-colors" data-id="element-157">
                <div className="w-16 h-16 mx-auto rounded-xl bg-pulse-blue/20 flex items-center justify-center mb-4" data-id="element-158">
                  <Icon className="h-8 w-8 text-pulse-blue" data-id="element-159" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-160">
                  {event.label}
                </h3>
                <p className="text-white/60 text-sm" data-id="element-161">{event.description}</p>
              </motion.div>;
        })}
        </div>

        {/* Features & CTA */}
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-162">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-163">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-164">
              Why Choose Pulse for Your Event?
            </h3>
            <ul className="space-y-4" data-id="element-165">
              {features.map((feature, index) => <motion.li key={feature} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-center gap-3" data-id="element-166">
                  <div className="w-6 h-6 rounded-full bg-pulse-yellow/20 flex items-center justify-center flex-shrink-0" data-id="element-167">
                    <CheckIcon className="h-4 w-4 text-pulse-yellow" data-id="element-168" />
                  </div>
                  <span className="text-white/80 font-medium" data-id="element-169">{feature}</span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center" data-id="element-170">
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-171">
              Be First in Line
            </h3>
            <p className="text-white/70 mb-6" data-id="element-172">
              Register your interest now and our events team will reach out as
              soon as bookings open.
            </p>
            <a href="#signup" className="inline-flex items-center justify-center gap-2 bg-pulse-yellow hover:bg-yellow-300 text-pulse-navy px-8 py-4 rounded-full font-bold uppercase tracking-wide transition-all hover:scale-105" data-id="element-173">
              Register Your Interest
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}